import { render, staticRenderFns } from "./Finalizar.vue?vue&type=template&id=b65ac592&scoped=true"
import script from "./Finalizar.vue?vue&type=script&lang=js"
export * from "./Finalizar.vue?vue&type=script&lang=js"
import style0 from "./Finalizar.vue?vue&type=style&index=0&id=b65ac592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65ac592",
  null
  
)

export default component.exports